/* eslint-disable react/prop-types */
import { connect } from "react-redux";
import { Link, useNavigate } from "react-router-dom";

function ActivateAccount() {
  const email = localStorage.getItem("email");

  const navigate = useNavigate();
  const validate = async (event) => {
    event.preventDefault();

    try {
      const response = await fetch(
        `${import.meta.env.VITE_REACT_APP_BACKEND_URL}/user/activate/${email}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include", // Correct placement of credentials
        }
      );

      const responseData = await response.json();

      if (!response.ok) {
        throw new Error(responseData.message || responseData.error);
      }

      // On successful activation, navigate to the login page
      navigate("/login");
    } catch (err) {
      // Handle errors (e.g., display error messages)
      console.log(err);
    }
  };

  return (
    <div className="login-form-bx">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-6 col-md-7 box-skew d-flex">
            <div className="authincation-content">
              <div className="mb-4">
                <h3 className="mb-1 font-w600">Welcome to Ordear</h3>
                <p className="">Activate Your Account To Sign in</p>
              </div>
              <button className="btn btn-primary btn-block" onClick={validate}>
                Activate
              </button>
            </div>
          </div>
          <div className="col-lg-6 col-md-5 d-flex box-skew1">
            <div className="inner-content align-self-center">
              <Link
                to="http://79.137.33.252:3001/dashboard"
                className="login-logo"
              >
                {/* <img src={logo} alt="" className="logo-icon me-2"/>
								<img src={logotext} alt="" className="logo-text ms-1"/> */}
                <h1 style={{ fontWeight: "bold" }}>ClicToEat</h1>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    errorMessage: state.auth.errorMessage,
    successMessage: state.auth.successMessage,
    showLoading: state.auth.showLoading,
  };
};
export default connect(mapStateToProps)(ActivateAccount);
